import React, { createContext, ReactNode, useContext } from 'react';
import { FlagState } from '../libs';
import { FLAG_SUP_FEATURES } from 'configs/featureFlags';
import { useTenantConfig } from './GlobalDataContext';

interface FeatureFlagProviderProps {
  children: ReactNode;
  flags?: FlagState;
}

interface FeatureFlagContextInterface {
  flags: FlagState;
}

const FeatureFlagContext = createContext<FeatureFlagContextInterface>({
  flags: FLAG_SUP_FEATURES,
});

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
  flags,
}: FeatureFlagProviderProps) => {
  flags = flags || FLAG_SUP_FEATURES;
  const { disableEpicEcom284 } = useTenantConfig();

  return (
    <FeatureFlagContext.Provider
      value={{
        flags: {
          ...flags,

          /**
            UX4BUYER-5240 additional platform flag.
            disableEpicEcom284 turns off the epic for a specific platform
          */
          epic_ecom_284: flags.epic_ecom_284 && !disableEpicEcom284,
        },
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => {
  return useContext(FeatureFlagContext);
};
